import { createReducer } from '@reduxjs/toolkit';
import { loadRoles } from 'redux/actions/roles';
import { initialRootState } from '.';

export default createReducer(initialRootState, builder => {
  builder
    .addCase(loadRoles, (state, action) => {
      state.models.roles = action.payload;
    });
});
